var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,{
      methods: {
        softDelete: _vm.softDelete,
        hardDelete: _vm.hardDelete,
        recover: _vm.recover,
        bulkSoftDelete: _vm.bulkSoftDelete,
        bulkHardDelete: _vm.bulkHardDelete,
        bulkRecover: _vm.bulkRecover,
        deleteMediaFile: _vm.deleteMediaFile,
      },
    })],2)}
var staticRenderFns = []

export { render, staticRenderFns }